import { cn } from "@/lib/utils";

interface PageContentProps {
  children: React.ReactNode;
  className?: string;
}

export function PageContent({ children, className }: PageContentProps) {
  return (
    <div className="bg-muted min-h-[calc(100vh-10rem)]">
      <div className={cn("rounded-lg p-6 max-w-5xl mx-auto", className)}>
        {children}
      </div>
    </div>
  );
}
